import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DateTime } from 'luxon';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ToggleButton from '@mui/material/ToggleButton';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';


import { createSearchParams, useNavigate } from 'react-router-dom';
import { baseUrl, apiHelper } from 'helpers/util';
import { notify } from 'helpers/globalFunctions';

import RowBox from 'components/RowBox';
import ColumnBox from 'components/ColumnBox';
import SmallHeading from 'components/SmallHeading';
import SmallestHeading from 'components/SmallestHeading';
import NormalText from 'components/NormalText';

export default function Form(props) {
    const warehouse = props.warehouse;

    const navigate = useNavigate();
    const [ menuRows, setMenuRows ] = useState([]);
    const [ menuDate, setMenuDate ] = useState(DateTime.now())
    const [ isMoreInfoDialogOpen, setIsMoreInfoDialogOpen ] = useState(false);
    const [ dialogText, setDialogText ] = useState('');

    const loadLedgerReport = function() {
        const apiParams = {
            "menu_date": menuDate.toFormat('yyyy-MM-dd'),
            "route": "store_manager.daily_cost_analysis" }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_custom_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) {
                setMenuRows(response.json.message.menu_rows) }
            else { console.log(response.json); }
        })
    }

    const handleMoreInfoDialogClose = function() {
        setIsMoreInfoDialogOpen(false);
    }

    const onClickInfo = function(info) {
        setDialogText(info);
        setIsMoreInfoDialogOpen(true);
    }

    useEffect(function() {
        loadLedgerReport();
    }, [])

    return (
        <Box sx={{ padding: '15px' }}>
            <SmallHeading>Daily Analysis</SmallHeading>
            <RowBox>
                <Box sx={{ marginRight: '10px', marginTop: '15px' }}>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                        <MobileDatePicker
                            onChange={(newValue) => { setMenuDate(newValue); }}
                            value={menuDate}
                            inputFormat="dd-MMM-yyyy"
                            mask=""
                            closeOnSelect={true}
                            disableMaskedInput={true}
                            renderInput={(params) => <TextField {...params}
                                label="Menu Date" size="small" sx={{ width: '100%' }} />}
                        />
                    </LocalizationProvider>
                </Box>
                <Button sx={{ marginRight: '10px', marginTop: '15px' }}
                    onClick={() => loadLedgerReport()} size="small"
                    variant="outlined">Search</Button>
            </RowBox>
            <ColumnBox>
            {menuRows.map((mr) => (
                <Box key={mr.menu_id} sx={{ marginBottom: '15px' }}>
                    <RowBox sx={{ alignItems: 'center' }}>
                        <SmallestHeading>{mr.menu_type}</SmallestHeading>
                        <IconButton onClick={ () => onClickInfo(mr.menu_details) }><InfoOutlinedIcon /></IconButton>
                    </RowBox>
                    <RowBox sx={{ justifyContent: 'space-between' }}>
                        <RowBox sx={{ alignItems: 'center' }}>
                            <NormalText sx={{ color: 'green', cursor: 'pointer' }}
                                onClick={() => onClickInfo(mr.cost_breakup)}>
                                ₹ {mr.total_cost}</NormalText>
                            <NormalText sx={{ fontWeight: 'bold' }}>&nbsp;&nbsp;/&nbsp;&nbsp;</NormalText>
                            <RowBox sx={{ alignItems: 'center', color: 'red', cursor: 'pointer' }}
                                onClick={ () => onClickInfo(mr.meal_breakup) }>
                                <NormalText>{mr.total_meals}</NormalText>&nbsp;
                                <PeopleAltOutlinedIcon sx={{ color: 'red' }} />
                            </RowBox>
                        </RowBox>
                        <NormalText sx={{ color: 'green', fontWeight: 'bold' }}>₹ {mr.per_meal_cost}</NormalText>
                    </RowBox>
                </Box>
            ))}
            </ColumnBox>
            <Dialog open={isMoreInfoDialogOpen} onClose={handleMoreInfoDialogClose}>
                <DialogContent sx={{ whiteSpace: 'pre', minWidth: '70vw' }}>
                    <NormalText>{dialogText}</NormalText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleMoreInfoDialogClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
